class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

function updateCartDrawerDescriptionText(count) {
  const description = document.getElementById('CartDrawer-Description');
  if (!description) {
    return;
  }

  const quantity = Number(count) || 0;
  const text =
    quantity === 1
      ? `${quantity} produkt i varukorgen`
      : `${quantity} produkter i varukorgen`;

  description.textContent = text;
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          // Update cart-drawer-items
          const targetItems = document.querySelector('cart-drawer-items');
          const sourceItems = html.querySelector('cart-drawer-items');
          if (targetItems && sourceItems) {
            targetItems.replaceWith(sourceItems);
          }
          
          // Update footer
          const targetFooter = document.getElementById('CartDrawer-Footer');
          const sourceFooter = html.querySelector('#CartDrawer-Footer');
          if (targetFooter && sourceFooter) {
            targetFooter.replaceWith(sourceFooter);
          }
          
          // Also update the total directly if footer update didn't work
          const totalElement = document.getElementById('CartDrawer-Total');
          const sourceTotal = html.querySelector('#CartDrawer-Total');
          if (totalElement && sourceTotal) {
            totalElement.textContent = sourceTotal.textContent;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    console.log('[Cart] updateQuantity called:', { line, quantity, name, variantId });
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    console.log('[Cart] Fetching cart update:', { url: routes.cart_change_url, body, sections: this.getSectionsToRender().map((section) => section.section) });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        console.log('[Cart] Response received:', { ok: response.ok, status: response.status, statusText: response.statusText });
        return response.text();
      })
      .then((state) => {
        console.log('[Cart] Response text:', state.substring(0, 200) + '...');
        const parsedState = JSON.parse(state);
        console.log('[Cart] Parsed state:', { 
          hasErrors: !!parsedState.errors, 
          errors: parsedState.errors,
          itemCount: parsedState.item_count,
          hasSections: !!parsedState.sections,
          sections: parsedState.sections ? Object.keys(parsedState.sections) : []
        });

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          // Clear any previous errors
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          console.log('[Cart] Error element:', errors);
          if (errors) {
            console.log('[Cart] Clearing error element');
            errors.textContent = '';
            errors.style.display = 'none';
          }

          if (parsedState.errors) {
            console.log('[Cart] Errors found in response:', parsedState.errors);
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            if (errors) {
              errors.textContent = parsedState.errors;
              errors.style.display = 'block';
              console.log('[Cart] Error displayed:', errors.textContent, errors.style.display);
            }
            return;
          }
          
          console.log('[Cart] No errors, proceeding with update');

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          updateCartDrawerDescriptionText(parsedState.item_count);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const sectionElement = document.getElementById(section.id);
            if (!sectionElement) {
              console.log('[Cart] Section element not found:', section.id);
              return;
            }
            
            const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
            if (elementToReplace && parsedState.sections[section.section]) {
              console.log('[Cart] Updating section:', section.id, section.section);
              const newContent = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
              if (newContent) {
                elementToReplace.innerHTML = newContent;
                console.log('[Cart] Section updated:', section.id);
              } else {
                console.log('[Cart] No content to update for section:', section.id);
              }
            } else {
              console.log('[Cart] Cannot update section:', { 
                id: section.id, 
                hasElement: !!elementToReplace, 
                hasSection: !!parsedState.sections[section.section] 
              });
            }
          });

          window.initialCart = parsedState;
          if (window.ProductCardController && typeof window.ProductCardController.updateButtonsWithCart === 'function') {
            window.ProductCardController.updateButtonsWithCart(parsedState);
          }
          
          // Also update individual item prices from the updated HTML if available
          if (this.tagName === 'CART-DRAWER-ITEMS' && parsedState.sections && parsedState.sections['cart-drawer']) {
            console.log('[Cart] Updating item prices from cart-drawer section');
            const cartDrawerHtml = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            if (parsedState.items) {
              parsedState.items.forEach((item, index) => {
                const sourcePriceElement = cartDrawerHtml.querySelector(`#CartDrawer-Item-Price-${index + 1}`);
                const targetPriceElement = document.getElementById(`CartDrawer-Item-Price-${index + 1}`);
                console.log('[Cart] Price update:', { index: index + 1, source: sourcePriceElement?.textContent, target: targetPriceElement?.textContent });
                if (targetPriceElement && sourcePriceElement) {
                  targetPriceElement.textContent = sourcePriceElement.textContent;
                }
              });
            }
          }
          
          // Update cart drawer footer if this is a cart drawer
          if (this.tagName === 'CART-DRAWER-ITEMS') {
            console.log('[Cart] Updating cart drawer footer');
            const updateCartDrawerFooter = () => {
              const targetFooter = document.getElementById('CartDrawer-Footer');
              const targetTotal = document.getElementById('CartDrawer-Total');
              console.log('[Cart] Footer elements:', { targetFooter: !!targetFooter, targetTotal: !!targetTotal });

              // If cart is empty, remove footer entirely
              if (parsedState.item_count === 0) {
                console.log('[Cart] Cart empty, removing footer');
                if (targetFooter) {
                  targetFooter.remove();
                }
                if (targetTotal) {
                  targetTotal.textContent = '';
                }
                return true;
              }
              
              // Try to get from parsed sections first
              if (parsedState.sections && parsedState.sections['cart-drawer']) {
                console.log('[Cart] Found cart-drawer section in response');
                const cartDrawerHtml = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
                const sourceFooter = cartDrawerHtml.querySelector('#CartDrawer-Footer');
                const sourceTotal = cartDrawerHtml.querySelector('#CartDrawer-Total');
                console.log('[Cart] Source footer elements:', { sourceFooter: !!sourceFooter, sourceTotal: !!sourceTotal, totalText: sourceTotal?.textContent });
                
                if (targetFooter && sourceFooter) {
                  console.log('[Cart] Replacing footer');
                  targetFooter.replaceWith(sourceFooter.cloneNode(true));
                  return true;
                } else if (targetTotal && sourceTotal) {
                  console.log('[Cart] Updating total:', sourceTotal.textContent);
                  targetTotal.textContent = sourceTotal.textContent;
                  return true;
                }
              } else {
                console.log('[Cart] No cart-drawer section in response');
              }
              return false;
            };
            
            // Try to update from sections
            const updated = updateCartDrawerFooter();
            console.log('[Cart] Footer update result:', updated);
            
            // If not updated from sections, fetch separately
            if (!updated) {
              console.log('[Cart] Fetching cart-drawer section separately');
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  console.log('[Cart] Fetched cart-drawer section');
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const sourceFooter = html.querySelector('#CartDrawer-Footer');
                  const sourceTotal = html.querySelector('#CartDrawer-Total');
                  const targetFooter = document.getElementById('CartDrawer-Footer');
                  const targetTotal = document.getElementById('CartDrawer-Total');
                  
                  if (targetFooter && sourceFooter) {
                    console.log('[Cart] Replacing footer from separate fetch');
                    targetFooter.replaceWith(sourceFooter.cloneNode(true));
                  } else if (targetTotal && sourceTotal) {
                    console.log('[Cart] Updating total from separate fetch:', sourceTotal.textContent);
                    targetTotal.textContent = sourceTotal.textContent;
                  }
                })
                .catch((e) => {
                  console.error('[Cart] Error updating cart drawer footer:', e);
                });
            }
          }
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error('[Cart] Error in updateQuantity:', error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        console.log('[Cart] Error element in catch:', errors);
        if (errors) {
          if (window.cartStrings) {
            errors.textContent = window.cartStrings.error;
          } else {
            errors.textContent = 'Ett fel uppstod när du uppdaterade din varukorg. Försök igen.';
          }
          errors.style.display = 'block';
          console.log('[Cart] Error displayed in catch:', errors.textContent, errors.style.display);
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.textContent = message;
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        if (cartStatus) {
          cartStatus.setAttribute('aria-hidden', true);
        }
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) {
      document.activeElement.blur();
    }
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
